<div [formGroup]="group" fxLayout="column" fxLayoutGap="16px">
  <mat-form-field>
    <mat-label>Webhook URL</mat-label>
    <input matInput formControlName="url" placeholder="https://example.com/webhook" />
    <mat-icon matSuffix>webhook</mat-icon>
    @if (group.get('url')?.invalid && group.get('url')?.touched) {
      <mat-error>Webhook URL is required</mat-error>
    }
  </mat-form-field>
  <div formGroupName="auth" fxLayout="column" fxLayoutGap="16px">
    <mat-form-field>
      <mat-label>Authorization Type</mat-label>
      <mat-select formControlName="type" placeholder="Type">
        <mat-option value="none">None</mat-option>
        <mat-option value="apiKey">Api Key</mat-option>
      </mat-select>
    </mat-form-field>
    @if (group.get('auth.type')?.value === 'apiKey') {
      <div formGroupName="config" fxLayout="column" fxLayoutGap="16px">
        <mat-form-field>
          <mat-label>Header Name</mat-label>
          <input matInput formControlName="headerName" placeholder="Header Name" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Header Value</mat-label>
          <input matInput formControlName="value" placeholder="Header Value" />
        </mat-form-field>
      </div>
    }
  </div>
  <div align="end">
    <button mat-button type="button" (click)="clearConfig()" [disabled]="group.pristine">
      <mat-icon>clear</mat-icon>
      Clear Webhook Configuration
    </button>
  </div>
</div>
